// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"8beb6293","453":"4437eca8"}[chunkId] + ".chunk.js";
};